import React, { useState, useEffect, useRef } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import HttpService from "../../services/httpService";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    makeStyles,
    Typography,
    useMediaQuery,
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Grid,
    FormControl,
    Modal,
    IconButton,
    FormControlLabel,
    Checkbox,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { CSVLink } from "react-csv";
import moment from "moment";
import CloseIcon from "@material-ui/icons/Close";
import VisibilityIcon from "@material-ui/icons/Visibility";
import {
    buildDesignHealthMDaySummaryQuery,
    resolveLeadCurrentStage,
    resolveLeadDesignerName,
    resolveLeadOdmManagerName,
    resolveLeadCityAgmName,
    formatDaysLapsedFromCommittedDate,
    formatDaysLapsedInCurrentDesignStage,
    designHealthDetailCellValue,
} from "../../utils/designHealthMDayBuckets";
import {
    IoMdArrowDroprightCircle,
    IoMdArrowDropdownCircle,
} from "react-icons/io";
import { Link } from "react-router-dom";
import Skeleton from '@material-ui/lab/Skeleton';
import { DownloadOutlined } from '@ant-design/icons';


const useStyles = makeStyles(() => ({
    paperWrapper: {
        padding: "2rem",
        borderRadius: "10px",
        boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
        backgroundColor: "#fff",
        marginBottom: "1.5rem",
    },
    tableContainer: {
        maxHeight: 688,
        overflow: "auto",
    },
    title: {
        fontWeight: 700,
        color: "#1e293b",
        marginBottom: "16px",
        textAlign: "center",
        fontSize: "20px",
    },
    headerCell: {
        backgroundColor: "#1C375D",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "16px",
        textAlign: "center",
        borderRight: "1px solid rgba(255,255,255,0.2)",
        borderBottom: "1px solid #fff",
        position: "sticky",
        top: 0,
        zIndex: 2,
    },
    topLeftHeader: {
        backgroundColor: "#1C375D",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "16px",
        textAlign: "center",
        padding: "16px",
        borderRight: "1px solid rgba(255,255,255,0.2)",
        borderBottom: "1px solid #fff",
        position: "sticky",
        top: 0,
        left: 0,
        zIndex: 5,
    },
    monthCell: {
        backgroundColor: "#1C375D",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "16px",
        textAlign: "center",
        padding: "16px",
        border: "1px solid #ddd",
        position: "sticky",
        left: 0,
        zIndex: 3,
    },
    bodyCell: {
        textAlign: "center",
        fontSize: "14px",
        padding: "16px",
        border: "1px solid #ddd",
        color: "#263238",
        backgroundColor: "#fff",
        cursor: "pointer"
    },
    button: {
        fontSize: "12px",
        textTransform: "none",
    },
    modalWrapper: {
        backgroundColor: "white",
        padding: 20,
        margin: "5% auto",
        width: "90%",
        maxHeight: "90vh",
        overflowY: "auto",
        borderRadius: 8,
    },
    modalHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 12,
    },
    closeButton: {
        color: "#000",
        padding: 6,
    },
    csv: {
        display: "flex",
        justifyContent: "flex-end",
        marginBottom: 16,
        gap: 10,
    },
    tableRowEven: {
        backgroundColor: "#f9f9f9",
    },
    tableRowOdd: {
        backgroundColor: "#fff",
    },
    valueCell: {
        fontSize: "14px",
        color: "#263238",
        padding: "10px",
        border: "1px solid #ddd",
        textAlign: "center",
    },
    bodyTotalCell: {
        textAlign: "center",
        fontSize: "16px",
        fontWeight: 700,
        padding: "16px",
        border: "1px solid #ddd",
        color: "#004d41",
        backgroundColor: "#ebebeb",
        cursor: "pointer",

    },
    secondHeaderRow: {
        backgroundColor: "#1C375D",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "16px",
        textAlign: "center",
        position: "sticky",
        top: 45,
        zIndex: 1,
        borderBottom: "1px solid #fff",
        borderRight: "1px solid rgba(255,255,255,0.2)",
    },
    mColumnHeaderInner: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 4,
    },
    mColumnEye: {
        color: "#FFF2EB",
        padding: 4,
    },

}));

const DesignHealth = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const csvButtonRef = useRef();
    const [designHealthTableCsvData, setDesignHealthTableCsvData] = useState([]);
    const designHealthTableCsvButtonRef = useRef(null);
    const [triggerDownload, setTriggerDownload] = useState(false);
    const { userDetails } = useSelector((state) => state.user);
    const [commonExpCenter, setExpCenter] = useState([]);
    const [commonLocation, setLocation] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState([]);
    const [selectedExperienceCenter, setSelectedExperienceCenter] = useState(
        []
    );
    const [storeDateFilter, setStoreDateFilter] = useState({
        startDate: "",
        endDate: "",
    });
    const [clearTriggered, setClearTriggered] = useState(false);
    const [showDetailedModal, setShowDetailedModal] = useState(false);
    const [modelData, setModelData] = useState([]);
    const [designData, setDesignData] = useState([]);
    const [selectedMonthType, setSelectedMonthType] = useState(null);

    useEffect(() => {
        if (clearTriggered) {
            designHealthData();
            setClearTriggered(false);
        }
    }, [clearTriggered]);

    useEffect(() => {
        designHealthData();
        expCenters();
        locations();
    }, []);

    const expCenters = async () => {
        props.setLoading(true);
        try {
            const res = await HttpService.getExpericenCenters();
            const matched = res.data.filter((e) =>
                userDetails.experienceCenterId.includes(e._id)
            );
            setExpCenter(matched);
        } catch (err) {
            props.setSnackInfo(
                err?.response?.data ?? "Something Went Wrong",
                "error"
            );
        }
        props.setLoading(false);
    };

    const locations = async () => {
        props.setLoading(true);
        try {
            const res = await HttpService.getLocation();
            // const matched = res.data.filter((e) =>
            //     userDetails.selectedLocation.includes(e._id)
            // );
            const userLocationIds = userDetails.locationId.map((e) =>
                typeof e === "object" ? e._id.toString() : e.toString()
            );
            const matched = res.data.filter((e) => userLocationIds.includes(e._id.toString()));
            setLocation(matched);
        } catch (err) {
            props.setSnackInfo(
                err?.response?.data ?? "Something Went Wrong",
                "error"
            );
        }
        props.setLoading(false);
    };

    // this is Bottom Up data API.
    const designHealthData = async () => {
        props.setLoading(true);

        try {
            let expCenterData = selectedExperienceCenter?.map((el) => el._id);
            let locationData = selectedLocation?.map((el) => el._id);
            let userExpeData = userDetails?.experienceCenterId?.map((el) => el);

            const obj = {
                startDate: storeDateFilter.startDate,
                endDate: storeDateFilter.endDate,
                selectedExperienceCenter: selectedExperienceCenter.map(el => el._id).join(","),
                selectedLocation: selectedLocation.map(el => el._id).join(","),
                userId: userDetails?._id,
                userExpeCenterId: userDetails?.experienceCenterId?.join(",") || "",
                monthType: selectedMonthType?.id || "",
            };

            props.setSnackInfo("Fetching Data...", "info");

            const response = await HttpService.designHealthCommitmentData(
                obj
            );
            if (response?.status === 200) {
                const { data } = response;
                if (data) {
                    setDesignData(data);
                    props.setSnackInfo("Data Fetched Successfully", "success");
                } else {
                    setDesignData([]);
                    props.setSnackInfo("No Data Found", "info");
                }
            } else {
                const errMsg =
                    response?.data?.message || "Failed to Fetch Data";
                props.setSnackInfo(errMsg, "error");
            }
        } catch (error) {
            console.error("Error fetching Bottoms Up Data:", error);

            // Extract detailed error message if available
            let message = "Something went wrong!";
            if (error?.response?.data?.message) {
                message = error.response.data.message;
            } else if (error?.message) {
                message = error.message;
            }

            props.setSnackInfo(message, "error");
        } finally {
            props.setLoading(false);
        }
    };

    const handleSubmitAllFilters = () => {
        designHealthData();
    };

    const handleClearAllFilters = () => {
        setSelectedLocation([]);
        setSelectedExperienceCenter([]);
        setStoreDateFilter({ startDate: "", endDate: "" });
        setSelectedMonthType(""); 
        // designHealthData();
        setClearTriggered(true);
    };

    const isSubmitDisabled = !(
        selectedLocation.length > 0 ||
        selectedExperienceCenter.length > 0 ||
        (storeDateFilter.startDate && storeDateFilter.endDate && selectedMonthType)
    );

    const headers = [
        { label: "Sl. No.", key: "index" },
        { label: "Customer Name", key: "customerName" },
        { label: "Project No.", key: "projectNo" },
        { label: "Lead No.", key: "leadNo" }, 
        { label: "Value (INR)", key: "value" },
        { label: "City", key: "city" },
        { label: "Exp. Ctr. Name", key: "expCenter" },
        { label: "Current Stage", key: "currentStage" },
        { label: "Days Lapsed in the Last Design Stage", key: "daysLapsedInCurrentDesignStage" },
        { label: "Designer", key: "designer" },
        { label: "ODM Manager", key: "odmManager" },
        { label: "Design AGM", key: "cityAgm" },
        { label: "Sales Won Date", key: "salesWonDate" },
        // {
        //     label: "Design Kick-Off Internal Approval Date",
        //     key: "designKickOffInternalApprovalDate",
        // },
        { label: "Tentative Design Closure Date (Committed Date)", key: "closureDate" },
        { label: "Days Lapsed From Committed Date", key: "daysLapsedFromCommitted" },
        { label: "Projection DSO Commited At", key: "projectionDSOCommitedUpdatedAt" },
        { label: "DSO Month Change (Slip On)", key: "designHealthSecondApprovalsDate" },
        { label: "Internal Design Sign-Off Date (IDSO)", key: "internalDesignSignOffDate" },
    ];

    const csvData = modelData.map((item, i) => ({
        _id: item?._id,
        index: i + 1,
        customerName: item?.customer?.name || "N/A",
        projectNo: item?.erpProjectNo || "N/A",
        leadNo: item?.lead_no || "N/A",
        value: item?.staticSalesWonBudget || "N/A",
        city: item?.cityName || "N/A",
        expCenter: item?.experienceCenterName || "N/A",
        currentStage: resolveLeadCurrentStage(item),
        daysLapsedInCurrentDesignStage: formatDaysLapsedInCurrentDesignStage(item),
        designer: resolveLeadDesignerName(item),
        odmManager: resolveLeadOdmManagerName(item),
        cityAgm: resolveLeadCityAgmName(item),
        salesWonDate: item?.leadWonDate
            ? moment(item?.leadWonDate).format("DD-MM-YYYY")
            : "-",
        // designKickOffInternalApprovalDate:
        //     item?.designKickOffInternalApprovalDate
        //         ? moment(item?.designKickOffInternalApprovalDate).format(
        //               "DD-MM-YYYY"
        //           )
                // : "-",
        closureDate: (item?.closureDate && item?.closureDate)
            ? moment(item?.closureDate).format("DD-MM-YYYY")
            : "-",
        daysLapsedFromCommitted: formatDaysLapsedFromCommittedDate(item?.closureDate),
        projectionDSOCommitedUpdatedAt: (item?.projectionDSOCommitedUpdatedAt && item?.projectionDSOCommitedUpdatedAt)
                ? moment(item?.projectionDSOCommitedUpdatedAt).format("DD-MM-YYYY")
                    : "-",
        designHealthSecondApprovalsDate: (item?.designHealthSecondApprovalsDate && item?.designHealthSecondApprovalsDate)
            ? moment(item?.designHealthSecondApprovalsDate).format("DD-MM-YYYY")
            : "-",
        internalDesignSignOffDate: (item?.internalDesignSignOffDate && item?.internalDesignSignOffDate)
            ? moment(item?.internalDesignSignOffDate).format("DD-MM-YYYY")
            : "-",
    }));

    const csvDownloadHandler = () => {
        if (csvButtonRef.current) {
            csvButtonRef.current.link.click();
        }
    };

    // Trigger CSV download when data is ready
    useEffect(() => {
        if (triggerDownload && designHealthTableCsvData.length > 0) {
            const timer = setTimeout(() => {
                if (designHealthTableCsvButtonRef.current?.link) {
                    try {
                        designHealthTableCsvButtonRef.current.link.click();
                    } catch (error) {
                        console.error("Error triggering CSV download:", error);
                        props?.setSnackInfo("Error downloading CSV", "error");
                    }
                    setTriggerDownload(false);
                } else {
                    // Retry if link is not ready
                    setTimeout(() => {
                        if (designHealthTableCsvButtonRef.current?.link) {
                            designHealthTableCsvButtonRef.current.link.click();
                            setTriggerDownload(false);
                        }
                    }, 200);
                }
            }, 300);
            
            return () => clearTimeout(timer);
        }
    }, [triggerDownload, designHealthTableCsvData]);

    // Function to generate CSV data for design health table
    const generateDesignHealthTableCsvData = () => {
        try {
            if (!designData || designData.length === 0) {
                return [];
            }

            const csvRows = [];

            // Build header row - match table structure exactly
            const headerRow = {
                "Committed Month / Sales Month": "",
                "Less than M - Count": "",
                "Less than M - Value": "",
                "M - Count": "",
                "M - Value": "",
                "M+1 - Count": "",
                "M+1 - Value": "",
                "M+2 - Count": "",
                "M+2 - Value": "",
                "More than M+2 - Count": "",
                "More than M+2 - Value": "",
                "Not Committed - Count": "",
                "Not Committed - Value": "",
                "Total - Count": "",
                "Total - Value": ""
            };
            csvRows.push(headerRow);

            // Add data rows for each month
            designData.forEach((row) => {
                const csvRow = {
                    "Committed Month / Sales Month": row?.month || "",
                    "Less than M - Count": row?.m0?.count || 0,
                    "Less than M - Value": row?.m0?.value || 0,
                    "M - Count": row?.m?.count || 0,
                    "M - Value": row?.m?.value || 0,
                    "M+1 - Count": row?.m1?.count || 0,
                    "M+1 - Value": row?.m1?.value || 0,
                    "M+2 - Count": row?.m2?.count || 0,
                    "M+2 - Value": row?.m2?.value || 0,
                    "More than M+2 - Count": row?.m3?.count || 0,
                    "More than M+2 - Value": row?.m3?.value || 0,
                    "Not Committed - Count": row?.notCommitted?.count || 0,
                    "Not Committed - Value": row?.notCommitted?.value || 0,
                    "Total - Count": row?.total?.count || 0,
                    "Total - Value": row?.total?.value || 0
                };
                csvRows.push(csvRow);
            });

            return csvRows;
        } catch (error) {
            console.error("Error generating design health table CSV:", error);
            return [];
        }
    };

    const openModel = (data) => {
        setModelData(data || []);
        setShowDetailedModal(true);
    };

    const openMDaySummaryTab = (salesMonth) => (event) => {
        event?.stopPropagation?.();
        event?.preventDefault?.();
        const query = buildDesignHealthMDaySummaryQuery({
            storeDateFilter,
            selectedExperienceCenter,
            selectedLocation,
            userDetails,
            selectedMonthType,
            salesMonth: salesMonth || "all",
        });
        window.open(
            `/design-health-m-day-summary?${query}`,
            "_blank",
            "noopener,noreferrer"
        );
    };

    const getMaxEndDate = (startDateStr) => {
        if (!startDateStr) return "";
        const start = new Date(startDateStr);
        const year = start.getFullYear();
        const month = start.getMonth();
        const maxEndDate = new Date(year, month + 4, 0);
        return maxEndDate.toISOString().split("T")[0];
    };

    const monthTypeOptions = [
        { id: "projectionDSOCommitedDate", name: "Commitment Month" },
        { id: "leadWonDate", name: "Sales Month" },
    ];


    return (
        <>
            {/*Filter Section */}
            <Paper className={classes.paperWrapper}>
                <Grid container spacing={2}>
                    
                    <Grid item xs={12} sm={3}>
                        <TextField
                            label="From Date"
                            type="date"
                            variant="outlined"
                            fullWidth
                            value={storeDateFilter.startDate}
                            InputLabelProps={{ shrink: true }}
                            onChange={(e) => {
                                const newStartDate = e.target.value;
                                const maxEnd = getMaxEndDate(newStartDate);

                                // Optional: reset endDate if it's outside new range
                                let adjustedEndDate = storeDateFilter.endDate;
                                if (adjustedEndDate && adjustedEndDate > maxEnd) {
                                    adjustedEndDate = "";
                                }

                                setStoreDateFilter({
                                    ...storeDateFilter,
                                    startDate: newStartDate,
                                    endDate: adjustedEndDate,
                                });
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <TextField
                            label="End Date"
                            type="date"
                            variant="outlined"
                            fullWidth
                            value={storeDateFilter.endDate}
                            InputLabelProps={{ shrink: true }}
                            // inputProps={{
                                // min: storeDateFilter.startDate || "",
                                // max: storeDateFilter.startDate
                                //     ? getMaxEndDate(storeDateFilter.startDate)
                                //     : "",
                            // }}
                            onChange={(e) =>
                                setStoreDateFilter({
                                    ...storeDateFilter,
                                    endDate: e.target.value,
                                })
                            }
                        />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <FormControl fullWidth>
                            <Autocomplete
                            value={selectedMonthType}
                            options={monthTypeOptions}
                            getOptionLabel={(option) => option.name}
                            onChange={(e, val) => setSelectedMonthType(val)}
                            renderInput={(params) => (
                                <TextField
                                {...params}
                                label="Select Month Type"
                                variant="outlined"
                                />
                            )}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <FormControl fullWidth>
                            <Autocomplete
                                multiple
                                value={selectedLocation}
                                options={commonLocation}
                                getOptionLabel={(option) => option.name}
                                // onChange={(e, val) => setSelectedLocation(val)}
                                onChange={(e, val) => {
                                    setSelectedLocation(val);
                                    if (val.length > 0) {
                                        const validLocationIds = val.map((loc) => loc._id);
                                        setSelectedExperienceCenter((prev) =>
                                            prev.filter((ec) =>
                                                validLocationIds.includes(ec.locationId?._id)
                                            )
                                        );
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label='Select Location'
                                        variant='outlined'
                                    />
                                )}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        <FormControl fullWidth>
                            <Autocomplete
                                multiple
                                value={selectedExperienceCenter}
                                // options={commonExpCenter}
                                options={
                                    selectedLocation.length > 0
                                        ? commonExpCenter.filter((ec) =>
                                            selectedLocation.some(
                                                (loc) => loc._id === ec.locationId?._id
                                            )
                                        )
                                        : commonExpCenter
                                }
                                getOptionLabel={(option) => option.name}
                                onChange={(e, val) =>
                                    setSelectedExperienceCenter(val)
                                }
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label='Select Exp-Center'
                                        variant='outlined'
                                    />
                                )}
                            />
                        </FormControl>
                    </Grid>
                </Grid>

                <Box mt={3} display='flex' gap={2} flexWrap='wrap'>
                    <Button
                        variant='contained'
                        color='primary'
                        style={{
                            color: "#fff",
                            padding: "6px 20px",
                            whiteSpace: "nowrap",
                            backgroundColor: isSubmitDisabled
                                ? "#cccccc"
                                : "#4caf50",
                            opacity: isSubmitDisabled ? 0.5 : 1,
                        }}
                        onClick={handleSubmitAllFilters}
                        disabled={isSubmitDisabled}>
                        Submit
                    </Button>
                    <Button
                        variant='contained'
                        color='secondary'
                        style={{ marginLeft: "10px" }}
                        onClick={handleClearAllFilters}>
                        Clear Filter
                    </Button>
                </Box>
            </Paper>
            {/*Filter Section */}

            <div className={classes.paperWrapper}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '20px', marginBottom: '20px', flexWrap: 'wrap' }}>
                        <Typography className={classes.title} style={{ marginBottom: 0 }}>
                            Design Health Summary Dashboard
                        </Typography>
                        <CSVLink
                            data={designHealthTableCsvData}
                            filename={`Design_Health_Summary_${moment().format('YYYY-MM-DD')}.csv`}
                            ref={designHealthTableCsvButtonRef}
                            style={{ textDecoration: 'none', display: 'none' }}
                        />
                        <Button
                            variant='contained'
                            startIcon={<DownloadOutlined />}
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                
                                const csvData = generateDesignHealthTableCsvData();

                                if (csvData.length > 0) {
                                    setDesignHealthTableCsvData(csvData);
                                    setTimeout(() => {
                                        setTriggerDownload(true);
                                    }, 100);
                                } else {
                                    props?.setSnackInfo("No data available to export", "warning");
                                }
                            }}
                            style={{
                                backgroundColor: "#355025",
                                color: "#FFF2EB",
                                padding: "0.4rem 2rem"
                            }}
                        >
                            Download CSV
                        </Button>
                    </div>
                    <TableContainer component={Paper} className={classes.tableContainer}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell
                                    className={classes.topLeftHeader}
                                    rowSpan={2}
                                >
                                    <div>committed month &gt;</div>
                                    <div>sales month v</div>
                                </TableCell>
                                {["Less than M", "M", "M+1", "M+2", "More than M+2", "Not Committed", "Total"].map((label, idx) => (
                                    <TableCell
                                        key={idx}
                                        className={classes.headerCell}
                                        colSpan={2}
                                    >
                                        {label === "M" ? (
                                            <span className={classes.mColumnHeaderInner}>
                                                M
                                                <IconButton
                                                    size="small"
                                                    className={classes.mColumnEye}
                                                    title="Open M month day-wise summary (new tab)"
                                                    onClick={openMDaySummaryTab("all")}
                                                >
                                                    <VisibilityIcon style={{ fontSize: 16 }} />
                                                </IconButton>
                                            </span>
                                        ) : (
                                            label
                                        )}
                                    </TableCell>
                                ))}
                            </TableRow>
                            <TableRow>
                                {Array(7)
                                    .fill()
                                    .flatMap(() => ["Count", "Value"])
                                    .map((label, idx) => (
                                        <TableCell
                                            key={idx}
                                            className={classes.secondHeaderRow}
                                        >
                                            {label}
                                        </TableCell>
                                    ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {designData?.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell className={classes.monthCell}>
                                        {row?.month}
                                    </TableCell>
                                    <TableCell className={row?.month === "Total" ? classes.bodyTotalCell : classes.bodyCell} onClick={()=>openModel(row?.m0?.data)} >{row?.m0?.count}</TableCell>
                                    <TableCell className={row?.month === "Total" ? classes.bodyTotalCell : classes.bodyCell} onClick={()=>openModel(row?.m0?.data)} >{row?.m0?.value}</TableCell>
                                    <TableCell className={row?.month === "Total" ? classes.bodyTotalCell : classes.bodyCell} onClick={() => openModel(row?.m?.data)}>{row?.m?.count}</TableCell>
                                    <TableCell className={row?.month === "Total" ? classes.bodyTotalCell : classes.bodyCell} onClick={() => openModel(row?.m?.data)}>{row?.m?.value}</TableCell>
                                    <TableCell className={row?.month === "Total" ? classes.bodyTotalCell : classes.bodyCell} onClick={()=>openModel(row?.m1?.data)} >{row?.m1?.count}</TableCell>
                                    <TableCell className={row?.month === "Total" ? classes.bodyTotalCell : classes.bodyCell} onClick={()=>openModel(row?.m1?.data)} >{row?.m1?.value}</TableCell>
                                    <TableCell className={row?.month === "Total" ? classes.bodyTotalCell : classes.bodyCell} onClick={()=>openModel(row?.m2?.data)} >{row?.m2?.count}</TableCell>
                                    <TableCell className={row?.month === "Total" ? classes.bodyTotalCell : classes.bodyCell} onClick={()=>openModel(row?.m2?.data)} >{row?.m2?.value}</TableCell>
                                    <TableCell className={row?.month === "Total" ? classes.bodyTotalCell : classes.bodyCell} onClick={()=>openModel(row?.m3?.data)} >{row?.m3?.count}</TableCell>
                                    <TableCell className={row?.month === "Total" ? classes.bodyTotalCell : classes.bodyCell} onClick={()=>openModel(row?.m3?.data)} >{row?.m3?.value}</TableCell>
                                    <TableCell className={row?.month === "Total" ? classes.bodyTotalCell : classes.bodyCell} onClick={()=>openModel(row?.notCommitted?.data)} >{row?.notCommitted?.count}</TableCell>
                                    <TableCell className={row?.month === "Total" ? classes.bodyTotalCell : classes.bodyCell} onClick={()=>openModel(row?.notCommitted?.data)} >{row?.notCommitted?.value}</TableCell>
                                    <TableCell className={row?.month === "Total" ? classes.bodyTotalCell : classes.bodyCell} onClick={()=>openModel(row?.total?.data)} >{row?.total?.count}</TableCell>
                                    <TableCell className={row?.month === "Total" ? classes.bodyTotalCell : classes.bodyCell} onClick={()=>openModel(row?.total?.data)} >{row?.total?.value}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>

            {/* Table Popup Modal Start  */}
            <Modal
                open={showDetailedModal}
                onClose={() => setShowDetailedModal(false)}>
                <Box className={classes.modalWrapper}>
                    {/* Header */}
                    <div className={classes.modalHeader}>
                        <Typography variant='h6'>Design Health Table</Typography> 
                        <IconButton
                            className={classes.closeButton}
                            onClick={() => setShowDetailedModal(false)}>
                            <CloseIcon />
                        </IconButton>
                    </div>

                    {/* CSV Download */}
                    <div className={classes.csv}>
                        <CSVLink
                            headers={headers}
                            filename={`designHealth.csv`}
                            data={csvData}
                            ref={csvButtonRef}
                            style={{ display: "none" }}
                        />
                        <Button
                            onClick={csvDownloadHandler}
                            variant='contained'
                            style={{
                                backgroundColor: "#355025",
                                color: "#FFF2EB",
                            }}>
                            Download CSV
                        </Button>
                    </div>

                    {/* Table Content */}
                    <TableContainer
                        component={Paper}
                        className={classes.tableContainer}>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    {headers.map((h) => (
                                        <TableCell
                                            key={h.key}
                                            className={classes.headerCell}>
                                            {h.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {csvData.length === 0 ? (
                                    <TableRow>
                                        <TableCell
                                            colSpan={headers.length}
                                            align='center'>
                                            No data available
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    csvData.map((row, i) => (
                                        <TableRow
                                            key={i}
                                            className={
                                                i % 2 === 0
                                                    ? classes.tableRowEven
                                                    : classes.tableRowOdd
                                            }>
                                            {headers.map((h) => {
                                                const isProjectNo =
                                                    h.key === "projectNo";
                                                const isLeadNo =
                                                    h.key === "leadNo";
                                                return (
                                                    <TableCell
                                                        key={h.key}
                                                        className={
                                                            classes.valueCell
                                                        }>
                                                        {(isProjectNo ||
                                                            isLeadNo) &&
                                                        row._id ? (
                                                            <a
                                                                href={`/project-logs/${row._id}`}
                                                                target='_blank'
                                                                rel='noopener noreferrer'
                                                                style={{
                                                                    color: "rgba(0, 0, 0, 0.87)",
                                                                    textDecoration:
                                                                        "underline",
                                                                }}>
                                                                {row[h.key]}
                                                            </a>
                                                        ) : (
                                                            designHealthDetailCellValue(row[h.key])
                                                        )}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Modal>
            {/* Popup Modal END  */}
        </>
    );
};

export default connect(null, { setLoading, setSnackInfo })(DesignHealth);
